import { Controller } from '@hotwired/stimulus';
import ApexCharts from 'apexcharts';

// Used in: coach ratio, irockers, new students, school overview, (school show = tbc)
// Purpose: Create a chart from the 'chartData' value given through html in dashboard controller using apex chart js
// FIX: Need to implement dashboard (pages) controller to use real data. Changing timeline needs to be either through a rails submit button or a javascript stimulus function that changes the value.
// Refactor: Check is there a better way than using global variables for charts array and chart options

// Global variable used to destroy charts on disconnect
let charts = [];
// Global variable for default chart options for chart colors, etc.
const allChartOptions = {
  irockers: {
    mainChartColors: {
      borderColor: '#374151',
      labelColor: '#9CA3AF',
      opacityFrom: 0,
      opacityTo: 0.15,
    },
    mainChartColorsDark: {
      borderColor: '#F3F4F6',
      labelColor: '#6B7280',
      opacityFrom: 0.45,
      opacityTo: 0,
    },
    chart: {
      height: 420,
      type: 'area',
      fontFamily: 'Open sans, Inter, sans-serif',
      foreColor: '#9CA3AF',
      toolbar: {
        show: false,
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        enabled: true,
        opacityFrom: 0.7,
        opacityTo: 0.15,
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      style: {
        fontSize: '14px',
        fontFamily: 'Open sans, Inter, sans-serif',
      },
    },
    // replaced by data from controller
    // series: [
    //   {
    //     name: 'Total students',
    //     data: [5812, 5918, 6156, 6226, 6356, 6556, 10000],
    //     stroke: {
    //       curve: 'straight',
    //       lineCap: 'butt',
    //       width: [50],
    //       dashArray: 5,
    //     },
    //     color: '#1A56DB',
    //   },
    //   {
    //     name: 'New students',
    //     data: [260, 300, 100, 120, 20, 300, 330],
    //     stroke: {
    //       curve: 'straight',
    //       lineCap: 'butt',
    //       dashArray: 5,
    //     },
    //     color: '#FDBA8C',
    //   },
    // ],
    grid: {
      show: true,
      borderColor: '#374151',
      strokeDashArray: 1,
      padding: {
        left: 35,
        bottom: 15,
      },
    },
    markers: {
      size: 5,
      strokeColors: '#ffffff',
      hover: {
        size: undefined,
        sizeOffset: 3,
      },
    },
    xaxis: {
      // replaced by data from controller
      // categories: ['Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
      labels: {
        style: {
          colors: ['#9CA3AF'],
          fontSize: '14px',
          fontWeight: 500,
        },
      },
      axisBorder: {
        color: '#374151',
      },
      axisTicks: {
        color: '#374151',
      },
      crosshairs: {
        show: true,
        position: 'back',
        stroke: {
          color: '#374151',
          width: 1,
          dashArray: 10,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: ['#9CA3AF'],
          fontSize: '14px',
          fontWeight: 500,
        },
        formatter: function (value) {
          return '' + value;
        },
      },
    },
    legend: {
      fontSize: '14px',
      fontWeight: 500,
      fontFamily: 'Open sans, Inter, sans-serif',
      labels: {
        colors: ['#9CA3AF'],
      },
      itemMargin: {
        horizontal: 10,
      },
    },
    responsive: [
      {
        breakpoint: 1024,
        options: {
          xaxis: {
            labels: {
              show: false,
            },
          },
          yaxis: {
            labels: {
              show: false,
            },
          },
        },
      },
    ],
  },
  paymentOverview: {
    mainChartColors: {
      borderColor: '#374151',
      labelColor: '#9CA3AF',
      opacityFrom: 0,
      opacityTo: 0.15,
    },
    mainChartColorsDark: {
      borderColor: '#F3F4F6',
      labelColor: '#6B7280',
      opacityFrom: 0.45,
      opacityTo: 0,
    },
    chart: {
      height: 420,
      type: 'area',
      fontFamily: 'Open sans, Inter, sans-serif',
      foreColor: '#9CA3AF',
      toolbar: {
        show: false,
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        enabled: true,
        opacityFrom: 0.7,
        opacityTo: 0.15,
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      style: {
        fontSize: '14px',
        fontFamily: 'Open sans, Inter, sans-serif',
      },
    },
    // replaced by data from controller
    // series: [
    //   {
    //     name: 'Total students',
    //     data: [5812, 5918, 6156, 6226, 6356, 6556, 6789],
    //     color: '#1A56DB',
    //   },
    //   {
    //     name: 'New students',
    //     data: [260, 300, 100, 120, 20, 300, 330],
    //     color: '#FDBA8C',
    //   },
    // ],
    grid: {
      show: true,
      borderColor: '#374151',
      strokeDashArray: 1,
      padding: {
        left: 35,
        bottom: 15,
      },
    },
    markers: {
      size: 5,
      strokeColors: '#ffffff',
      hover: {
        size: undefined,
        sizeOffset: 3,
      },
    },
    xaxis: {
      // replaced by data from controller
      // categories: ['Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
      labels: {
        style: {
          colors: ['#9CA3AF'],
          fontSize: '14px',
          fontWeight: 500,
        },
      },
      axisBorder: {
        color: '#374151',
      },
      axisTicks: {
        color: '#374151',
      },
      crosshairs: {
        show: true,
        position: 'back',
        stroke: {
          color: '#374151',
          width: 1,
          dashArray: 10,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: ['#9CA3AF'],
          fontSize: '14px',
          fontWeight: 500,
        },
        formatter: function (value) {
          return '' + value;
        },
      },
    },
    legend: {
      fontSize: '14px',
      fontWeight: 500,
      fontFamily: 'Open sans, Inter, sans-serif',
      labels: {
        colors: ['#9CA3AF'],
      },
      itemMargin: {
        horizontal: 10,
      },
    },
    responsive: [
      {
        breakpoint: 1024,
        options: {
          xaxis: {
            labels: {
              show: false,
            },
          },
          yaxis: {
            labels: {
              show: false,
            },
          },
        },
      },
    ],
  },
  chargeableStudents: {
    mainChartColors: {
      borderColor: '#374151',
      labelColor: '#9CA3AF',
      opacityFrom: 0,
      opacityTo: 0.15,
    },
    mainChartColorsDark: {
      borderColor: '#F3F4F6',
      labelColor: '#6B7280',
      opacityFrom: 0.45,
      opacityTo: 0,
    },
    chart: {
      height: 420,
      type: 'area',
      fontFamily: 'Open sans, Inter, sans-serif',
      foreColor: '#9CA3AF',
      toolbar: {
        show: false,
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        enabled: true,
        opacityFrom: 0.7,
        opacityTo: 0.15,
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      style: {
        fontSize: '14px',
        fontFamily: 'Open sans, Inter, sans-serif',
      },
    },
    // replaced by data from controller
    // series: [
    //   {
    //     name: 'Total students',
    //     data: [5812, 5918, 6156, 6226, 6356, 6556, 6789],
    //     color: '#1A56DB',
    //   },
    //   {
    //     name: 'New students',
    //     data: [260, 300, 100, 120, 20, 300, 330],
    //     color: '#FDBA8C',
    //   },
    // ],
    grid: {
      show: true,
      borderColor: '#374151',
      strokeDashArray: 1,
      padding: {
        left: 35,
        bottom: 15,
      },
    },
    markers: {
      size: 5,
      strokeColors: '#ffffff',
      hover: {
        size: undefined,
        sizeOffset: 3,
      },
    },
    xaxis: {
      // replaced by data from controller
      // categories: ['Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
      labels: {
        style: {
          colors: ['#9CA3AF'],
          fontSize: '14px',
          fontWeight: 500,
        },
      },
      axisBorder: {
        color: '#374151',
      },
      axisTicks: {
        color: '#374151',
      },
      crosshairs: {
        show: true,
        position: 'back',
        stroke: {
          color: '#374151',
          width: 1,
          dashArray: 10,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: ['#9CA3AF'],
          fontSize: '14px',
          fontWeight: 500,
        },
        formatter: function (value) {
          return '' + value;
        },
      },
    },
    legend: {
      fontSize: '14px',
      fontWeight: 500,
      fontFamily: 'Open sans, Inter, sans-serif',
      labels: {
        colors: ['#9CA3AF'],
      },
      itemMargin: {
        horizontal: 10,
      },
    },
    responsive: [
      {
        breakpoint: 1024,
        options: {
          xaxis: {
            labels: {
              show: false,
            },
          },
          yaxis: {
            labels: {
              show: false,
            },
          },
        },
      },
    ],
  },
  newStudents: {
    colors: ['#1A56DB', '#FDBA8C'],
    // replaced by data from controller
    // series: [
    //   {
    //     name: 'New Students',
    //     color: '#1A56DB',
    //     data: [
    //       { x: 'Mar', y: 170 },
    //       { x: 'Apr', y: 180 },
    //       { x: 'May', y: 164 },
    //       { x: 'Jun', y: 145 },
    //       { x: 'Jul', y: 174 },
    //       { x: 'Aug', y: 170 },
    //       { x: 'Sep', y: 450 },
    //     ],
    //   },
    //   {
    //     name: 'Cancellations',
    //     color: '#FDBA8C',
    //     data: [
    //       { x: 'Mar', y: 5 },
    //       { x: 'Apr', y: 6 },
    //       { x: 'May', y: 12 },
    //       { x: 'Jun', y: 4 },
    //       { x: 'Jul', y: 120 },
    //       { x: 'Aug', y: 5 },
    //       { x: 'Sep', y: 10 },
    //     ],
    //   },
    // ],
    chart: {
      type: 'bar',
      height: '350px',
      fontFamily: 'Open sans, Inter, sans-serif',
      foreColor: '#4B5563',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        columnWidth: '50%',
        borderRadius: 3,
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      style: {
        fontSize: '14px',
        fontFamily: 'Open sans, Inter, sans-serif',
      },
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 1,
        },
      },
    },
    stroke: {
      show: true,
      width: 5,
      colors: ['transparent'],
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    xaxis: {
      floating: true,
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: false,
    },
    fill: {
      opacity: 1,
    },
  },
  coachRatio: {
    coachesChartColors: {
      fillGradientShade: 'light',
      fillGradientShadeIntensity: 1,
    },
    coachesChartColorsDark: {
      fillGradientShade: 'dark',
      fillGradientShadeIntensity: 0.45,
    },
    // replaced by data from controller
    // series: [
    //   {
    //     name: 'Coaches',
    //     data: [58, 62, 59, 51, 62, 55, 54],
    //   },
    // ],

    // labels: ['Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
    chart: {
      type: 'area',
      height: '350px',
      fontFamily: 'Open sans, Inter, sans-serif',
      sparkline: {
        enabled: true,
      },
      toolbar: {
        show: false,
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        shadeIntensity: 1,
      },
    },
    plotOptions: {
      area: {
        fillTo: 'end',
      },
    },
    theme: {
      monochrome: {
        enabled: true,
        color: '#1A56DB',
      },
    },
    tooltip: {
      style: {
        fontSize: '14px',
        fontFamily: 'Open sans, Inter, sans-serif',
      },
    },
  },
  schoolsOverview: {
    schoolsOverviewChartColors: {
      strokeColor: '#ffffff',
    },
    schoolsOverviewChartColorsDark: {
      strokeColor: '#111827',
    },
    // replaced by data from controller
    // series: [635, 204, 88]
    labels: ['Active', 'Created', 'Cancelled'],
    // colors: ['#16BDCA', '#FDBA8C', '#1A56DB', '#D61F69', '#9061F9', '#6875F5'],
    colors: ['#16BDCA', '#FDBA8C', '#D61F69'],
    chart: {
      type: 'donut',
      height: 305,
      fontFamily: 'Open sans, Inter, sans-serif',
      toolbar: {
        show: false,
      },
    },
    stroke: {
      colors: '#ffffff',
    },
    plotOptions: {
      pie: {
        donut: {
          size: '5%',
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.9,
        },
      },
    },
    tooltip: {
      shared: true,
      followCursor: false,
      fillSeriesColor: false,
      inverseOrder: true,
      style: {
        fontSize: '14px',
        fontFamily: 'Open sans, Inter, sans-serif',
      },
      x: {
        show: true,
        formatter: function (_, { seriesIndex, w }) {
          const label = w.config.labels[seriesIndex];
          return label;
        },
      },
      y: {
        formatter: function (value) {
          return value + '%';
        },
      },
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
  },
  studentOverview: {
    studentsOverviewChartColors: {
      strokeColor: '#ffffff',
    },
    studentsOverviewChartColorsDark: {
      strokeColor: '#111827',
    },
    // replaced by data from controller
    // series: [635, 204, 88]
    labels: [
      'signed_up',
      'assigned',
      'space_reserved',
      'starting_soon',
      'preactive',
      'active',
      'offered_but_no_payment',
      'requested_transfer',
      'leaving',
      'previously_active',
      'cancelled',
    ],
    // colors: ['#16BDCA', '#FDBA8C', '#1A56DB', '#D61F69', '#9061F9', '#6875F5'],
    colors: [
      '#3e7af1', // signed_up - Blue
      '#b4c1cc', // assigned - Gray
      '#f0fd08', // space_reserved - Yellow
      '#fac29b', // starting_soon - Peach
      '#31c48d', // preactive - Teal
      '#31c48d', // active - Green
      '#e74694', // offered_but_no_payment - Pink
      '#b4c1cc', // requested_transfer - Light Blue Gray
      '#4bc4d0', // leaving - Cyan
      '#d2dfea', // previously_active - Light Blue
      '#f05252', // cancelled - Red
    ],

    chart: {
      type: 'donut',
      height: 305,
      fontFamily: 'Open sans, Inter, sans-serif',
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      pie: {
        donut: {
          size: '50%',
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.9,
        },
      },
    },
    tooltip: {
      shared: true,
      followCursor: false,
      fillSeriesColor: false,
      inverseOrder: true,
      style: {
        fontSize: '14px',
        fontFamily: 'Open sans, Inter, sans-serif',
      },
      x: {
        show: true,
        formatter: function (_, { seriesIndex, w }) {
          const label = w.config.labels[seriesIndex];
          return label;
        },
      },
      y: {
        formatter: function (value) {
          return value + '%';
        },
      },
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
  },

  schoolShow: {
    mainChartColors: {
      borderColor: '#374151',
      labelColor: '#9CA3AF',
      opacityFrom: 0,
      opacityTo: 0.15,
    },
    mainChartColorsDark: {
      borderColor: '#F3F4F6',
      labelColor: '#6B7280',
      opacityFrom: 0.45,
      opacityTo: 0,
    },
    chart: {
      height: 420,
      type: 'area',
      fontFamily: 'Open sans, Inter, sans-serif',
      foreColor: '#9CA3AF',
      toolbar: {
        show: false,
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        enabled: true,
        opacityFrom: 0.7,
        opacityTo: 0.15,
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      style: {
        fontSize: '14px',
        fontFamily: 'Open sans, Inter, sans-serif',
      },
    },
    grid: {
      show: true,
      borderColor: '#374151',
      strokeDashArray: 1,
      padding: {
        left: 35,
        bottom: 15,
      },
    },
    // replaced by data from controller
    // series: [
    //   {
    //     name: 'Total students',
    //     data: [5812, 5918, 6156, 6226, 6356, 6556, 6789],
    //     color: '#1A56DB',
    //   },
    //   {
    //     name: 'New students',
    //     data: [260, 300, 100, 120, 20, 300, 330],
    //     color: '#FDBA8C',
    //   },
    // ],
    markers: {
      size: 5,
      strokeColors: '#ffffff',
      hover: {
        size: undefined,
        sizeOffset: 3,
      },
    },
    xaxis: {
      categories: ['Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
      labels: {
        style: {
          colors: ['#9CA3AF'],
          fontSize: '14px',
          fontWeight: 500,
        },
      },
      axisBorder: {
        color: '#374151',
      },
      axisTicks: {
        color: '#374151',
      },
      crosshairs: {
        show: true,
        position: 'back',
        stroke: {
          color: '#374151',
          width: 1,
          dashArray: 10,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: ['#9CA3AF'],
          fontSize: '14px',
          fontWeight: 500,
        },
        formatter: function (value) {
          return '' + value;
        },
      },
    },
    legend: {
      fontSize: '14px',
      fontWeight: 500,
      fontFamily: 'Open sans, Inter, sans-serif',
      labels: {
        colors: ['#9CA3AF'],
      },
      itemMargin: {
        horizontal: 10,
      },
    },
    responsive: [
      {
        breakpoint: 1024,
        options: {
          xaxis: {
            labels: {
              show: false,
            },
          },
        },
      },
    ],
  },
};

export default class extends Controller {
  static targets = ['chart'];
  static values = {
    chartData: Object,
  };

  connect() {
    console.log('chart controller connected');
    console.log('this.chartDataValue:', this.chartDataValue);
  }

  // Is called on initalize and when the chartData value changes
  chartDataValueChanged() {
    console.log('chart value changed');
    // Re-create the chart, once data has changed (ex. when select different timeframe)
    let chartOptions = this.setChartData();
    this.createChart(chartOptions);
  }

  createChart(chartOptions) {
    console.log('create chart');
    // Render the chart in the appropriate target with the relevant chart options
    const chart = new ApexCharts(this.chartTarget, chartOptions);
    chart.render();
    const currentDate = new Date();
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const currentMonth = monthNames[currentDate.getMonth()];
    const currentYear = currentDate.getFullYear();
    const formattedMonth = `${currentMonth} ${currentYear}`;

    chart.updateOptions({
      annotations: {
        xaxis: [
          {
            x: formattedMonth,
            borderColor: '#23272e',
          },
        ],
      },
    });

    charts.push(chart);
  }

  setChartData() {
    console.log('set chart data');
    // Get relevant chart options
    let chartOptions = allChartOptions[this.chartDataValue.chart];
    // Assign series data from the chart data object in html
    chartOptions.series = this.chartDataValue.series;
    // Assign chart specific options
    if (this.chartDataValue.xaxis_categories) chartOptions.xaxis.categories = this.chartDataValue.xaxis_categories;
    if (this.chartDataValue.labels) chartOptions.labels = this.chartDataValue.labels;
    console.log('chartoptions', chartOptions);
    return chartOptions;
  }

  disconnect() {
    console.log('disconnect');
    this.destroyChart();
  }

  destroyChart() {
    console.log('destroy');
    charts.forEach(function (chart) {
      chart.destroy();
    });
  }
}
